
export const DEFAULT_CHART_COLORS = ['#003b61', '#046997', '#318db2', '#7ec8db', '#bee3ed', '#003b61', '#046997', '#318db2', '#7ec8db', '#bee3ed', '#003b61', '#046997', '#318db2', '#7ec8db', '#bee3ed'];
export const colorss = ['#046997', '#318db2', '#7ec8db'];
export const CountriesColors = ['#003b61', '#046997', '#318db2', '#7ec8db', '#bee3ed', '#EF9A9A', '#F48FB1', '#CE93D8', '#B39DDB', '#B39DDB', '#9FA8DA', '#90CAF9', '#81D4FA', '#80DEEA', '#80CBC4', '#A5D6A7', '#C5E1A5', '#E6EE9C', '#FFF59D', '#FFE082', '#FFCC80', '#FFAB91', '#BCAAA4', '#EEEEEE', '#B0BEC5'];
export const statisticColors = ['#003b61', '#034e71', '#046997', '#318db2', '#5fb2d3', '#8acdde', '#bee3ed',];
export const customLabel = (p) => {
    return `${p.name}: ${p.value}`;
};
export const llabel = (p) => {
    return `${p.value}`;
};

export const RADIAN = Math.PI / 180;


export const legendStyle = {
    left: '15px',
    top: '25%',
    lineHeight: '29px',
    wordWrap: 'break-word'
};

export const center = {
    margin: '0 auto',
};
export const citizenshipTypeOptions = [
    {
        key: 0,
        value: 0,
        text: 'BH državljani',
        name: 'BH državljani'
    },
    {
        key: 1,
        value: 1,
        text: 'Strani državljani',
        name: 'Strani državljani'
    },
    {
        key: 2,
        value: 2,
        text: 'Svi državljani',
        name: 'Svi državljani'
    }
];


export default { DEFAULT_CHART_COLORS };



// WEBPACK FOOTER //
// ./src/views/Statistics/util.js